module.exports = __webpack_public_path__ + "img/step4-09.c1e04829.jpg";